/* eslint-disable no-unused-vars */
export enum PROMO_CODE_TYPES {
  fixed = 'FIXED',
  percentage = 'PERCENT',
  delivery = 'DELIVERY'
}
